import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../General/tiles.css', './login.component.css']
})
export class LoginComponent {

  public language: string;
  public name: string;
  public classid: string;

  showConfigTip: boolean = true;
  showStateTip: boolean = true;

  private readonly configID = 1;


  constructor(public appService: AppService, protected http: HttpClient) {
    this.language = this.appService.languageAbbreviation;

    if (appService.configuration == undefined || appService.configuration == null) {
      this.loadStandardConfig();
    }
  }

  ngAfterViewInit(): void {
    this.checkConfigID();
  }

  private checkConfigID() {
    //If config file is not meant for this einfachinformatik version.
    //If id is not defined, its an old config files. We don't want to interfere
    if (this.appService.configuration != undefined && this.appService.configuration != null) {
      if (this.appService.getConfigID() != undefined) {
        if (this.appService.getConfigID() != this.configID) {
          this.loadStandardConfig();
        }
      }
    }
  }

  /** get text in right language 
  * @param {string} tag - text to load
  */
  get(tag: string): String {
    return this.appService.get(tag);
  }

  /** load the configuration */
  loadConfig($event): void {
    this.appService.loadConfig($event.target);
  }

  /** load the state */
  loadState($event): void {
    this.appService.loadState($event.target);
  }

  /** load the state */
  storeConfig(): void {
    this.appService.storeConfigTeacher();
  }

  /** store the configuration for student */
  storeConfigStudent(): void {
    this.appService.storeConfigStudent();
  }

  /** load the state */
  storeState(): void {
    this.appService.storeState();
  }

  /** changes the language */
  onChangeLanguage() {
    this.appService.changeLanguage(this.language);
  }


  loadConfigEmpty(): void {
    let self = this;
    let filename: string = "./assets/empty_config.json";

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfigNoAlert();
    });

  }

  hasExercises(): boolean {
    return (this.appService.getAllTopics().length > 0);
  }

  /** load a predefined configuration --> typically not visible, can be used for demonstrations */
  loadStandardConfig(): void {
    let self = this;
    let filename: string = "./assets/" + this.language + "_book_config.json";

    /* ### DEMO ###
    this line is used for the demo. Uncomment it if you build a demo version
    
    filename = "./assets/"+this.language+"_book_config_teacher.json";*/

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
    });
  }

  loadStandardConfigTeacher(): void {
    let self = this;
    let filename: string = "./assets/" + this.language + "_book_config.json";

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
      self.appService.configuration.teachersplace = "true";
    });
  }

}
